import React from "react";
import { Badge, Box, Flex, Text } from "@chakra-ui/react";

const COLOR_BY_CATEGORY = {
  technical: "purple",
  functional: "orange",
  business: "green",
};

/**
 * Render a labeled row of skill chips for one category.
 * Returns null when `skills` is empty/falsy so callers can render unconditionally.
 */
const SkillChipGroup = ({ label, skills, category = "technical" }) => {
  if (!skills?.length) return null;
  const color = COLOR_BY_CATEGORY[category] || "blue";
  return (
    <Box>
      <Text fontSize="xs" textTransform="uppercase" color="gray.500" mb={1}>
        {label}
      </Text>
      <Flex wrap="wrap" gap={1}>
        {skills.map((s, i) => (
          <Badge key={i} colorScheme={color} variant="subtle" fontSize="xs" px={2} py={0.5}>
            {s}
          </Badge>
        ))}
      </Flex>
    </Box>
  );
};

export default SkillChipGroup;
